import { compact } from 'lodash';

import {
  entityPlugin as Entity,
  errorPlugin as Error,
} from '@zapier/toolbox-redux-framework';

import Auth from 'app/auth';
import Billing from 'app/billing';
import CompanyAccount from 'app/company-account';
import Login from 'app/login';
import Min from 'app/min';
import Partner from 'app/partner';
import Refresh from 'app/refresh';
import Rover from 'app/rover';
import Service from 'app/service';
import Team from 'app/team';
import TeamAccount from 'app/team-account';
import TeamExperts from 'app/team-experts';
import Track from 'app/track';
import TwoFactor from 'app/two-factor';
import Unsubscribe from 'app/unsubscribe';
import Zapbook from 'app/zapbook';
import safeExtend from 'app/common/utils/safeExtend';

const appPlugins = [
  Track,
  Auth,
  Service,
  Error,
  Min,
  Login,
  TwoFactor,
  Entity,
  Team,
  CompanyAccount,
  TeamAccount,
  TeamExperts,
  Zapbook,
  Billing,
  Partner,
  Refresh,
  Rover,
  Unsubscribe,
];

export default function () {
  return {
    all: appPlugins,

    get routes() {
      // Grab all the route objects.
      const routeArgs = compact(appPlugins.map(plugin => plugin.routes));

      // Make sure they're all unique.
      const safeExtendRouteArgs = [{}].concat(routeArgs);

      return safeExtend(...safeExtendRouteArgs);
    },

    get reducers() {
      return appPlugins.map(plugin => plugin.reducers);
    },

    get actionsTypes() {
      return appPlugins.map(plugin => plugin.actionTypes);
    },
  };
}
